/**
 * @fileoverview User Session Constants
 * Constants used by user session token provider cache/retry behavior.
 */

export const MAINTAIN_SESSION = {
  STORAGE_KEY: 'KeyUserSessionTokenMaintain',
  USER_ID_KEY: 'user_id',
  TOKEN_TTL_MS: 1 * 60 * 60 * 1000, // 1 hour
  MSG_FAILED_TOKEN_WRITE: 'Failed to write user token to sessionStorage',
  MSG_FAILED_TOKEN_READ: 'Failed to read user token from sessionStorage',
}

/**
 * Http Header Keys
 * Constants for HTTP header keys used in API requests.
 */
export const AUTH_STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  ID_TOKEN: 'id_token',
} as const
